import { Strings } from "src/constants";
import { AnalyticBody } from "./analyticBody";

export class EppAnalyticBody extends AnalyticBody {
    title: string = Strings.ANALYSIS_EPP_COMPE
}